import { initialState } from '../initialState'
import { createReducer } from '@reduxjs/toolkit'
import { settingsActionType } from '../actions/settings'

/**
 * @typedef {import("../initialState").StateSettings} InitialStateSettings
 * @typedef {import("../actions/settings").EntityOperationAction} EntityOperationAction
 */

const settings = createReducer(initialState.settings, {
  [settingsActionType.SET_CURRENT_LANGUAGE]: (state, action) => {
    state.language = action.payload.language
  },

  [settingsActionType.CLEAR_NOTICE]: (state, action) => {
    state.clearedNotices.push(action.payload)
  },

  [settingsActionType.SET_CURRENT_COUNTRY]: (state, action) => {
    state.country = action.payload.country
  },

  [settingsActionType.SET_CURRENT_STATE_PROVINCE]: (state, action) => {
    state.stateProvince = action.payload.stateProvince
  },

  /**
   * Save the entity operation into session state.
   * @param {InitialStateSettings} state
   * @param {EntityOperationAction} action
   */
  [settingsActionType.SAVE_ENTITY_OPERATION]: (state, action) => {
    const { operationId, operation, attributes } = action.payload
    state.entityOperation[operationId] = {
      operationId,
      operation,
      attributes,
    }
  },

  /**
   * Clean the entity operation from session state.
   * @param {InitialStateSettings} state
   * @param {EntityOperationAction} action
   */
  [settingsActionType.CLEAN_ENTITY_OPERATION]: (state, action) => {
    const { operationId } = action.payload
    state.entityOperation[operationId] = null
  },

})

export default settings
